import { type BlokAsset } from '~/types';
import {
    type SimpleProductDataFragment,
    ProductMediaShotType,
    ProductMediaOrientation,
} from '~~/graphql';

type Media = SimpleProductDataFragment['medias'][0];

/** Transform image object.
 * In order to get image from Storblok to work among with product images we have to transform it to Media object.
 */
export default function transformImageObject(object: BlokAsset): Media {
    return {
        __typename: 'ProductImage',
        id: object.id,
        title: object.alt,
        url: object.filename || '',
        height: 1080,
        width: 1920,
        shotType: ProductMediaShotType.WhiteBackground,
        orientation: ProductMediaOrientation.Landscape,
        position: 999, // 999 to make sure it's last.
        isDefault: false,
    };
}
